import React, { FC } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/global.css';

import Navbar from './components/Navbar';
import { Footer } from './components/SharedComponents';
import { useScrollToTop } from './hooks/useScrollToTop';

import Home from './pages/Home';
import { Company, Products, Services, Software, Branches, Contact } from './pages/OtherPages';
import { BarcodeLabels, TtrRibbons, Printers, Scanners, JewelleryLabels, TaffetaLabels, RetailPOS } from './pages/ProductPages';
import IndustryDetailPage, { IndustriesPage } from './pages/IndustryPages';
import SubcategoryDetailPage from './pages/SubcategoryDetailPage';

const ScrollToTop: FC = () => { useScrollToTop(); return null; };

const App: FC = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Navbar />
    <main>
      <Routes>
        <Route path="/"                              element={<Home />} />
        <Route path="/company"                       element={<Company />} />
        <Route path="/products"                      element={<Products />} />

        {/* Product category pages */}
        <Route path="/barcode-labels"                element={<BarcodeLabels />} />
        <Route path="/ttr-ribbons"                   element={<TtrRibbons />} />
        <Route path="/printers"                      element={<Printers />} />
        <Route path="/scanners"                      element={<Scanners />} />
        <Route path="/jewellery-labels"              element={<JewelleryLabels />} />
        <Route path="/taffeta-labels"                element={<TaffetaLabels />} />
        <Route path="/retail-pos"                    element={<RetailPOS />} />

        {/* Subcategory detail pages */}
        <Route path="/barcode-labels/:subcatSlug"   element={<SubcategoryDetailPage />} />
        <Route path="/ttr-ribbons/:subcatSlug"       element={<SubcategoryDetailPage />} />
        <Route path="/printers/:subcatSlug"          element={<SubcategoryDetailPage />} />
        <Route path="/scanners/:subcatSlug"          element={<SubcategoryDetailPage />} />
        <Route path="/jewellery-labels/:subcatSlug"  element={<SubcategoryDetailPage />} />
        <Route path="/taffeta-labels/:subcatSlug"    element={<SubcategoryDetailPage />} />
        <Route path="/retail-pos/:subcatSlug"        element={<SubcategoryDetailPage />} />

        {/* Industry pages */}
        <Route path="/industries"                    element={<IndustriesPage />} />
        <Route path="/industries/:id"                element={<IndustryDetailPage />} />

        {/* Other pages */}
        <Route path="/services"                      element={<Services />} />
        <Route path="/software"                      element={<Software />} />
        <Route path="/branches"                      element={<Branches />} />
        <Route path="/contact"                       element={<Contact />} />
        <Route path="*"                              element={<Home />} />
      </Routes>
    </main>
    <Footer />
  </BrowserRouter>
);

export default App;
